import React from "react"
import idHelper from "@irati/utils/id"
import authentication from "@irati/auth"
import WalletLink from "../../shared/WalletLink"

interface Props {
  id?: string
  text: string
  onClick: () => void
}

const UserWallet: React.FC<Props> = (props) => {
  const {onClick, text} = props
  const showUserCurrencyWallet = authentication.apps("wallet.users")
  const showFlexiPoints = authentication.apps("wallet.treatTokens")
  const showFlexiRewards = authentication.apps("wallet.flexiRewards")

  if (!showUserCurrencyWallet && !showFlexiPoints && !showFlexiRewards) {
    return null
  }

  return <WalletLink id={idHelper("link-wallet", props)} onClick={onClick} text={text} to="/" />
}

export default UserWallet
